export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
}

export const blobImageExtension = (blob) => {
  const mimePrefix = 'image/';
  if (blob?.type && blob.type?.includes(mimePrefix)) {
    return blob.type.replace(mimePrefix, '').replace('+xml','');
  }
}